




import { JSONEditor, Content } from 'vanilla-jsoneditor'
import { Component, Prop, Vue } from 'vue-property-decorator'

// JSONEditor properties as of version 0.3.60
const propNames = [
  'content',
  'mode',
  'mainMenuBar',
  'navigationBar',
  'statusBar',
  'readOnly',
  'indentation',
  'tabSize',
  'escapeControlCharacters',
  'escapeUnicodeCharacters',
  'validator',
  'onError',
  'onChange',
  'onChangeMode',
  'onClassName',
  'onRenderValue',
  'onRenderMenu',
  'queryLanguages',
  'queryLanguageId',
  'onChangeQueryLanguage',
  'onFocus',
  'onBlur'
]

function pickDefinedProps(object: any, propNames: any) {
  const props: any = {}
  for (const propName of propNames) {
    if (object[propName] !== undefined) {
      props[propName] = object[propName]
    }
  }
  return props
}

@Component
export default class VueJSONEditor extends Vue {
  @Prop({ required: true }) content: Content
  @Prop({ default: true }) readOnly: boolean
  @Prop() onChange: any

  private editor: any

  mounted() {
    this.editor = new JSONEditor({
      target: this.$refs.editor as Element,
      props: pickDefinedProps(this, propNames)
    })
  }

  updated() {
    this.updateProps()
  }

  beforeUnmount() {
    this.editor.destroy()
    this.editor = null
  }

  private updateProps() {
    const props = pickDefinedProps(this, propNames)
    this.editor.updateProps(props)
  }
}
